import UserSurveyComponent from '../../components/userSurvey/survey';

export default function UserSurvey() {
    
    return (
        <div className="grid nested-grid col-12 mt-0">
            <div className="grid col-12 lg:col-12 ml-0 pl-0 pt-0">
                <div className='col-12 pl-0'>
                    <UserSurveyComponent />
                </div>
            </div>
        </div>
    )
}